import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : time;
  };

  const timerComponents = [];

  if (Object.keys(timeLeft).length > 0) {
    timerComponents.push(
      <span key="days">
        {timeLeft.days}d-
      </span>
    );
    timerComponents.push(
      <span key="hours">
        {formatTime(timeLeft.hours)}:
      </span>
    );
    timerComponents.push(
      <span key="minutes">
        {formatTime(timeLeft.minutes)}:
      </span>
    );
    timerComponents.push(
      <span key="seconds">
        {formatTime(timeLeft.seconds)}
      </span>
    );
  } else {
    return <span>Expired</span>;
  }

  return (
    <span className="font-mono font-bold text-red-600">
      {timerComponents}
    </span>
  );
};

export default CountdownTimer;
